import React from 'react';
import { Modal } from '@components-shared/modal/Modal';
import { keyMap } from '@locales/lokalise/keyMap';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import { UserUpdateBankDetailsForm } from './UserUpdateBankDetailsForm';
import { UserUpdateBankDetailsMessage } from './UserUpdateBankDetailsMessage';
import styles from './userUpdateBankDetails.styles.module.scss';

export const UserUpdateBankDetailsModal = observer(() => {
  const {
    accountStore,
    popupModalStore: {
      isUpdateBankCardModalShown,
      openCloseUpdateBankCardModal,
      fetchUserBankCardRequiresUpdatesAndShowModal,
    },
  } = useMobxStore();

  const { userInfo } = accountStore;

  return !isUpdateBankCardModalShown ? null : (
    <Modal
      classNameContainer={styles.modal}
      showModalCloseButton={true}
      closeHandler={() => openCloseUpdateBankCardModal(false)}
      closeOnEscKey={false}>
      <UserUpdateBankDetailsMessage
        title={keyMap.profileWarningMessageBankCardRequiresUpdatesTitle}
        username={userInfo.displayName}
        messages={[
          keyMap.profileWarningMessageBankCardRequiresUpdates,
          keyMap.profileWarningMessageBankCardProvideInfo,
          keyMap.profileWarningMessageBankCardRequiresUpdatesReview,
        ]}
      />

      <UserUpdateBankDetailsForm
        onSuccess={fetchUserBankCardRequiresUpdatesAndShowModal}
        onClose={openCloseUpdateBankCardModal}
      />
    </Modal>
  );
});
